import axios from 'axios';
import Cookies from 'universal-cookie';
import api, { Method } from 'src/utils/apiManager.utils';
import { refreshTokenHeader } from 'src/utils/authFunctions.utils';
import { apiUrls, backendBaseURL } from 'src/utils/properties';

const AUTH_API_URL = backendBaseURL + apiUrls.AUTH;

const logIn = (credentials) => {
  return axios.post(AUTH_API_URL + apiUrls.LOG_IN, credentials, {
    withCredentials: true
  });
};

const switchToStudent = (credentials) => {
  return axios.post(AUTH_API_URL + apiUrls.SWITCH_TO_STUDENT, credentials, {
    withCredentials: true
  });
};

const switchToStudentFromStudent = (credentials) => {
  return axios.post(
    AUTH_API_URL + '/switch-to-student-from-student',
    credentials,
    {
      withCredentials: true
    }
  );
};

const backToParent = () => {
  return axios.post(AUTH_API_URL + apiUrls.BACK_TO_PARENT, '', {
    withCredentials: true
  });
};

const forgotPassword = (data) => {
  return axios.post(AUTH_API_URL + '/forgot-password', data);
};

const verifyEmail = (data: Object) => {
  return axios.post(AUTH_API_URL + '/verify-email', data);
};

const resetPassword = (data) => {
  return axios.post(AUTH_API_URL + '/reset-password', data);
};

const accessTokenGenerate = async () => {
  const cookies = new Cookies();
  const loggedInType = await cookies.get('logged_in_type');

  return axios.post(
    AUTH_API_URL + `/refresh-access-token/${loggedInType}`,
    {
      headers: refreshTokenHeader()
    },
    { withCredentials: true }
  );
};

const parentSignUp = async (data: Object) => {
  return axios.post(AUTH_API_URL + '/parent-signup', data);
};

const updateParentStatus = async (token: string) => {
  return axios.put(AUTH_API_URL + `/parent/update/${token}`);
};

const parentLogout = async () =>
  new Promise((resolve, reject) => {
    api(
      Method.POST,
      { withCredentials: false },
      apiUrls.AUTH + apiUrls.PARENT_LOG_OUT,
      '',
      '',
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

const studentLogout = async () =>
  new Promise((resolve, reject) => {
    api(
      Method.POST,
      { withCredentials: false },
      apiUrls.AUTH + apiUrls.STUDENT_LOG_OUT,
      '',
      '',
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export {
  logIn,
  forgotPassword,
  verifyEmail,
  resetPassword,
  accessTokenGenerate,
  parentSignUp,
  updateParentStatus,
  parentLogout,
  studentLogout,
  switchToStudent,
  backToParent,
  switchToStudentFromStudent
};
